import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { accountKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';
import type { PageParams } from '@/types/api';

export function useAccountReels(id: string | undefined, params: PageParams = {}) {
  return useQuery({
    queryKey: accountKeys.reels(id ?? '', params),
    queryFn: () => analyticsApi.reelsByAccount(id!, params),
    enabled: !!id,
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
    placeholderData: keepPreviousData,
  });
}
